// VideoSection.js - VERSÃO FINAL CORRIGIDA
import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import {
  Card,
  Typography,
  useMediaQuery,
  Box,
  CircularProgress,
} from "@mui/material";
import api from "../../../services/api";
import "./styles.css";

export function VideoSection({
  videoId,
  videoIndex,
  cursoId,
  trilha,
  modulo,
  playlistItems, // Array de videos_vistos
  onAtualiza, // Callback para atualizar a lista
}) {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [currentTime, setCurrentTime] = useState(0);
  const [pausado, setPausado] = useState(0);
  const [duracao, setDuracao] = useState(0);
  const [visto, setVisto] = useState(false);
  const [playerReady, setPlayerReady] = useState(false);
  const [salvando, setSalvando] = useState(false);

  // CORREÇÃO: Buscar dados do vídeo atual corretamente
  const videoAtual =
    playlistItems?.find((video) => video.video === videoId) || {};
  const noventaECinco = duracao * 0.95;

  // INICIALIZAÇÃO: Carregar dados salvos do vídeo
  useEffect(() => {
    if (videoAtual && videoId) {
      setVisto(videoAtual.visto || false);
      setPausado(videoAtual.pausado || 0);
      setDuracao(videoAtual.duracao || 0);
      setCurrentTime(videoAtual.pausado || 0);
      setPlayerReady(false);
    }
  }, [videoId, videoAtual.video]); // Depende do videoId e video atual

  // SALVAMENTO: Enviar atualizações para API
  useEffect(() => {
    // Validações antes de salvar
    if (!videoId || !trilha?.id || !modulo?.id || !videoAtual?.video) {
      return;
    }

    // Não salvar no primeiro render ou quando não há progresso real
    if (duracao === 0 && pausado === 0 && !visto) {
      return;
    }

    // Evitar salvamentos duplicados
    if (salvando) {
      return;
    }

    setSalvando(true);

    const videoPayload = {
      trilhaId: trilha.id,
      moduloId: modulo.id,
      videoId: videoAtual.video,
      visto,
      pausado: Math.floor(pausado),
      duracao: Math.floor(duracao),
    };

    api
      .patch("/trilhas-de-conhecimento/inscricao/atualizar-video", videoPayload)
      .then((response) => {
        if (visto && typeof onAtualiza === "function") {
          setTimeout(() => {
            onAtualiza();
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("❌ Erro ao salvar progresso:", error);
      })
      .finally(() => {
        setSalvando(false);
      });
  }, [visto, pausado, duracao]);

  const handleProgress = (state) => {
    setCurrentTime(state.playedSeconds);

    if (state.playedSeconds >= noventaECinco && !visto && duracao > 0) {
      setVisto(true);
    }
  };

  const handlePause = () => {
    const tempoAtual = Math.floor(currentTime);

    setPausado(tempoAtual);
  };

  const handleDuration = (duration) => {
    setDuracao(duration);
  };

  const handleEnded = () => {
    setVisto(true);
    setPausado(Math.floor(duracao));
  };

  const handleReady = () => {
    setPlayerReady(true);
  };

  const playerKey = `player-${videoId}-${videoAtual.video}`;

  return (
    <Card
      className="video-card"
      style={{
        height: isSmallScreen ? "100%" : "100%",
        width: "100%",
        position: "relative",
      }}
    >
      <div className="video-section">
        <div className="player-wrapper" style={{ position: "relative" }}>
          {videoId && videoAtual?.video ? (
            <>
              <ReactPlayer
                key={playerKey}
                url={`https://www.youtube.com/watch?v=${videoId}`}
                className="react-player"
                width="100%"
                height="100%"
                controls
                playing={false}
                onProgress={handleProgress}
                onPause={handlePause}
                onEnded={handleEnded}
                onDuration={handleDuration}
                onReady={handleReady}
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      rel: 0,
                      enablejsapi: 1,
                      origin: window.location.origin,
                      iv_load_policy: 3,
                      showinfo: 0,
                      start: Math.floor(pausado) || 0,
                    },
                  },
                }}
              />

              {/* Indicador de salvamento */}
              {salvando && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    backgroundColor: "rgba(0,0,0,0.7)",
                    color: "white",
                    padding: "4px 8px",
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    fontSize: "12px",
                  }}
                >
                  <CircularProgress size={12} color="inherit" />
                  Salvando...
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
              }}
            >
              <Typography color="text.secondary">
                Selecione um vídeo para assistir
              </Typography>
            </Box>
          )}
        </div>

        {/* Informações de debug - Remover em produção
        {process.env.NODE_ENV === "development" && videoId && (
          <Box
            sx={{
              padding: 1,
              fontSize: 11,
              color: "#666",
              backgroundColor: "#f9f9f9",
              borderTop: "1px solid #e0e0e0",
            }}
          >
            <div>
              <strong>Debug Info:</strong>
            </div>
            <div>ID: {videoId}</div>
            <div>Status: {visto ? "✅ Visto" : "⏳ Em progresso"}</div>
            <div>
              Tempo: {Math.floor(currentTime)}s / {Math.floor(duracao)}s
            </div>
            <div>Pausado em: {pausado}s</div>
            <div>
              Progresso:{" "}
              {duracao > 0 ? Math.round((currentTime / duracao) * 100) : 0}%
            </div>
            <div>Player: {playerReady ? "✅ Pronto" : "⏳ Carregando"}</div>
            {salvando && <div style={{ color: "orange" }}>💾 Salvando...</div>}
          </Box>
        )} */}
      </div>
    </Card>
  );
}

export default VideoSection;
